import { render, staticRenderFns } from "./StoryBoardMain.vue?vue&type=template&id=251b89e5&scoped=true"
import script from "./StoryBoardMain.vue?vue&type=script&lang=js"
export * from "./StoryBoardMain.vue?vue&type=script&lang=js"
import style0 from "./StoryBoardMain.vue?vue&type=style&index=0&id=251b89e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251b89e5",
  null
  
)

export default component.exports